import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

// Common Fragments
import { CompensationFragment, ReviewFragment } from "../../common/fragments";

export const approveAllTechniciansWashout = async (...params) => {
	const [userId, locationId, commissionCycleId, payPeriodId, position] = params;
	const query = gql`
		mutation approveAllTechniciansWashout(
			$userId: String!
			$locationId: String!
			$commissionCycleId: String!
			$payPeriodId: String!
			$position: String
		) {
			approveAllTechniciansWashout(
				userId: $userId
				locationId: $locationId
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				position: $position
			) {
				success
			}
		}
	`;
	const variables = {
		userId,
		locationId,
		commissionCycleId,
		payPeriodId,
		position,
	};

	try {
		const { data } = await apiInstance.post("/graphql", { query, variables });
		return data.data?.approveAllTechniciansWashout;
	} catch (error) {
		errorLogger(error);
		return null;
	}
};

export async function updateTechniciansWashout(...params) {
	const [locationId, dataInput, position] = params;
	const query = gql`
		mutation updateTechniciansWashout($locationId: String!, $input: WashoutInput!, $position: String) {
			updateTechniciansWashout(locationId: $locationId, input: $input, position: $position) {
				_id
				commissionCycleId
				payPeriodId
				userId
				summary {
					...Compensation
				}
			}
		}
		${CompensationFragment}
	`;

	const variables = {
		locationId,
		position,
		input: dataInput,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateTechniciansWashout;
	} catch (error) {
		errorLogger(error);
		return null;
	}
}

export async function updateTechniciansWashoutStatus(...params) {
	const [locationId, commissionCycleId, payPeriodId, userId, input, position] = params;
	const query = gql`
		mutation updateTechniciansWashoutStatus(
			$locationId: String!
			$commissionCycleId: String!
			$payPeriodId: String!
			$userId: String!
			$reviewInput: WashoutReviewInput
			$position: String
		) {
			updateTechniciansWashoutStatus(
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				locationId: $locationId
				reviewInput: $reviewInput
				userId: $userId
				position: $position
			) {
				_id
				commissionCycleId
				payPeriodId
				userId
				position
				status
				review {
					...Review
				}
				employee {
					position
				}
			}
		}
		${ReviewFragment}
	`;

	const variables = { locationId, commissionCycleId, payPeriodId, userId, position, reviewInput: input };

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateTechniciansWashoutStatus;
	} catch (error) {
		errorLogger(error);
		return null;
	}
}

export async function generateTechniciansWashout(...params) {
	const [locationId, commissionCycleId, payPeriodId, userIds] = params;
	const query = gql`
		mutation generateWashouts($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!, $userIds: [String!]!) {
			generateWashouts(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userIds: $userIds) {
				success
			}
		}
	`;
	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
		userIds,
	};
	try {
		const response = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.generateWashouts;
	} catch (error) {
		errorLogger(error);
		return null;
	}
}
